module.exports = __webpack_public_path__ + "img/z-solution-img2.7529ee21.png";